const WORDS = ["KVALITĀTE", "PIEREDZE", "UZTICAMĪBA", "GARANTIJA", "ĀTRI UN GODĪGI"];

export const Marquee = () => (
  <div data-testid="marquee" className="relative border-y border-white/10 bg-[#0b0b0f] py-5">
    <div className="hatch absolute inset-0 opacity-30" />
    <div className="relative flex overflow-hidden">
      <div className="marquee-track flex shrink-0 items-center whitespace-nowrap">
        {[...WORDS, ...WORDS, ...WORDS, ...WORDS].map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-head text-2xl font-extrabold uppercase italic tracking-tight text-slate-300 sm:text-4xl">
              {w}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-rose-500" />
          </span>
        ))}
      </div>
    </div>
  </div>
);
